import { render, staticRenderFns } from "./EditSignaturePage.vue?vue&type=template&id=4a8ff792&"
import script from "./EditSignaturePage.vue?vue&type=script&lang=js&"
export * from "./EditSignaturePage.vue?vue&type=script&lang=js&"
import style0 from "./EditSignaturePage.vue?vue&type=style&index=0&id=4a8ff792&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports